<template>
    <ul class="nav justify-content-center h-m-nav-social">
        <li class="nav-item">
            <a href="/login/oauth/facebook" class="nav-link link-facebook" title="Facebook" @click.prevent="track($event, 'Facebook')">
                <i class="fab fa-facebook-square d-block"></i>
            </a>
        </li>
        <li class="nav-item">
            <a href="/login/oauth/google" class="nav-link nav-link-stack link-google" title="Google" @click.prevent="track($event, 'Google')">
                <span class="fa-stack d-block">
                    <i class="fas fa-square fa-stack-2x"></i>
                    <i class="fab fa-google fa-stack-1x fa-inverse"></i>
                </span>
            </a>
        </li>
        <li class="nav-item">
            <a href="/login/oauth/twitter" class="nav-link link-twitter" title="Twitter" @click.prevent="track($event, 'Twitter')">
                <i class="fab fa-twitter-square d-block"></i>
            </a>
        </li>
        <li class="nav-item">
            <a href="/login/oauth/github" class="nav-link link-github" title="Github" @click.prevent="track($event, 'Github')">
                <i class="fab fa-github-square d-block"></i>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        methods: {

            track(event, method)
            {
                let $elm = event.target;

                if ($elm.tagName !== "a") {
                    $elm = $elm.closest("a");
                }

                const link = $elm.getAttribute("href");

                if (!link)
                {
                    alert('Desculpe, ocorreu um erro inesperado! Por favor, atualize a página e tente novamente ou entre em contato com nosso suporte.');
                    return;
                }

                // Tag do GA4
                if (typeof window.gtag !== 'undefined' && typeof window.GA4_MEASUREMENT_ID !== 'undefined')
                {
                    gtag('event', 'form_inicio', {
                        'send_to': window.GA4_MEASUREMENT_ID,
                        'method': method,
                        'event_callback': () => {
                            window.location.href = link;
                        }
                    });
                }
                else {
                    window.location.href = link;
                }
            }
        }
    }
</script>

<style lang="stylus">
    .h-m-nav-social
        .nav-link
            padding 0
            font-size 3rem
            width 3rem

            .fa-stack
                width 2em
                font-size .5em
</style>